
import React from "react";
import { useQueryTimeTables } from "../../hooks/useQueryTimeTables";

export const QueryTimeTables = (props) => {
  const [platformCode, nowTime] = props;
  const { status, data } = useQueryTimeTables(platformCode);
  if (status === "loading") return <div></div>;
  if (status === "error") return <div></div>;
  const nextTimeTable = data.filter((output, index) => {
    return output.departure_time > nowTime;
  });
  return nextTimeTable;

};


